import TileGridContainer from 'features/tiles/tileGridContainer';
import { FC } from 'react';
import TileWithoutDefaultStyling from 'features/tiles/tileWithoutDefaultStyling';
import { useGetWebhooksQuery } from 'app/apis/queryApi';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import Spinner from 'common/components/loading/spinner';
import NavLinkButton from 'common/components/anchors/navlink-button';
import { ButtonTheme } from 'common/components/buttons/button-theme';
import WebhooksTable from 'features/webhooks/webhooks-table/webhooks-table';

export const SettingsWebhooksPage: FC = () => {
  const { siteId } = useSelector((state: RootState) => state.selectedSite);

  const { data: webhooksResult, isLoading: isFetchingWebhooks } =
    useGetWebhooksQuery({
      siteId
    });

  return (
    <TileGridContainer>
      <TileWithoutDefaultStyling className="bg-white border rounded border-neutral-200 p-2.5 shadow-sm w-full grow basis-full">
        <section className="mx-6 my-6">
          <div className="flex items-center justify-between border-b border-neutral-200 pb-4 mb-4 mt-2">
            <h2 className="text-primary-700 text-l">Your Webhooks</h2>

            <NavLinkButton
              identifier="create-webhook"
              theme={ButtonTheme.PRIMARY}
              to="/settings/webhooks/create"
              classOverrides="py-2 px-4"
            >
              <span>Create Webhook</span>
            </NavLinkButton>
          </div>

          {isFetchingWebhooks ? (
            <div className="flex justify-center">
              <Spinner />
            </div>
          ) : (
            <>
              {webhooksResult && webhooksResult.webhooks.length > 0 ? (
                <WebhooksTable webhooks={webhooksResult.webhooks} />
              ) : (
                <div>
                  <i className="ra-icons-generic-spanner-wrench text-neutral-500 text-4xl text-center block"></i>
                  <h2 className="text-center text-xl">No Webhooks</h2>
                  <p className="text-center mt-1 text-sm">
                    You currently have no Webhooks configured.
                  </p>
                </div>
              )}
            </>
          )}
        </section>
      </TileWithoutDefaultStyling>
    </TileGridContainer>
  );
};
